import React from "react";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { Typography } from "@material-ui/core";
import Box from "../../../../../../ui/Box";
import SquareButton from "../../../../../../ui/SquareButton";
import Button from "../../../../../../ui/Button";

const useStyles = makeStyles(() => ({
  topBar: {
    display: "flex",
    justifyContent: "space-between"
  },
  topBarLeft: {
    display: "flex",
    "& > button": {
      marginRight: 12
    }
  },
  topBarRight: {
    display: "flex",
    "& > div": {
      marginLeft: 12
    }
  }
}));

const TopBar = ({
                  reload,
                  returnBack,
                  isUpdating,
                  update,
                  sendToExpertise,
                  sendToDevelop,
                  sendToPublication,
                  approveExpertise,
                  rejectExpertise,
                  approvePublication,
                  rejectPublication,
                  disabled,
                  created,
                  status
                }) => {
  const classes = useStyles();

  return (
    <Box>
      <div className={classes.topBar}>
        <div className={classes.topBarLeft}>
          <SquareButton onClick={returnBack}>
            <ChevronLeftIcon fontSize="small" />
          </SquareButton>
          <SquareButton onClick={reload}>
            <CachedIcon fontSize="small" />
          </SquareButton>
        </div>

        <div className={classes.topBarRight}>
          {status == 1 && <>
          <Button
            onClick={update}
            disabled={disabled || isUpdating || update == null}
            loading={isUpdating}
            color="green">
            Сохранить
          </Button><div></div>
                {created &&
                <Button
                  onClick={sendToExpertise}
                  disabled={disabled || isUpdating || sendToExpertise == null}
                  //loading={isUpdating}
                  color="blue">
                  НА ЭКСПЕРТИЗУ
                </Button>}
            </> }

          { status == 2 && <>
            <Button
              onClick={sendToDevelop}
              disabled={disabled || isUpdating || sendToDevelop == null}
              color="blue">
              НА ДОРАБОТКУ
            </Button>
            <div></div>
            <Button
              onClick={approveExpertise}
              disabled={disabled || isUpdating || approveExpertise == null}
              color="green">
              ПОДТВЕРДИТЬ
            </Button>
            <div></div>
            <Button
              onClick={rejectExpertise}
              disabled={disabled || isUpdating || rejectExpertise == null}
              color="pink">
              ОТКЛОНИТЬ
            </Button>
          </>}

          {status == 3 &&
            <Button
              onClick={sendToPublication}
              disabled={disabled || isUpdating || sendToPublication == null}
              color="blue">
              НА ПУБЛИКАЦИЮ
            </Button>
          }

          {status == 5 && <>
            <Button
              onClick={approvePublication}
              disabled={disabled || isUpdating || approvePublication == null}
              color="green">
              ОПУБЛИКОВАТЬ
            </Button>
            <div></div>
            <Button
              onClick={rejectPublication}
              disabled={disabled || isUpdating || rejectPublication == null}
              color="pink">
              ОТКЛОНИТЬ
            </Button>
          </>}

        </div>

      </div>
    </Box>
  );
};

export default withRouter(TopBar);
